import { secondDimensionSize } from 'sharedComponents/BuyBox/utils/sizes'
import Variant, { Sizes } from 'store/entities/Product/Variant'
import {
  COOKIE_SIZE_ADVISOR,
  RECOMMENDED_SIZES_TADARIDA_COOKIE_NAME,
} from './cookie'

const getSizeTexts = (sizes: Sizes, isSecondDimension: boolean) => {
  const hideAltSizeText = sizes.vendor === sizes.shop
  if (isSecondDimension) {
    return {
      sizeText: sizes.length
        ? sizes.length
        : secondDimensionSize({ sizes }) || '',
      altSizeText: null,
    }
  }
  return {
    sizeText: sizes.vendor,
    altSizeText: hideAltSizeText ? null : sizes.shop,
  }
}

const readCookieValue = <T = unknown>(cookieName: string) => {
  const allCookies = document.cookie

  const cookieRegex = new RegExp(`${cookieName}=(.*?)(;|$)`)

  const match = allCookies.match(cookieRegex)
  if (match != null) {
    const [, encodedValue] = match

    return JSON.parse(decodeURIComponent(encodedValue)) as T
  }
}

export interface CookieSize {
  id: number
  size: string
}

export const getRecommendedSizes = () => {
  const recommendedSizes = readCookieValue<CookieSize[]>(
    RECOMMENDED_SIZES_TADARIDA_COOKIE_NAME,
  )
  if (recommendedSizes) {
    return recommendedSizes
  }
  return readCookieValue<CookieSize[]>(COOKIE_SIZE_ADVISOR) || []
}

export const getRecommendedSizeVariant = (sizeOptions: Variant[]) => {
  const sizes = getRecommendedSizes().map(({ size }) => size)

  return sizeOptions.find(variant => {
    const { sizeText } = getSizeTexts(variant.sizes, false)
    return sizes.includes(sizeText)
  })
}
